import { ref, readonly } from 'vue'
import { alertEnum } from '@/enums/AlertEnum'
import Alert, { type AlertOptions } from '@/types/Alert'

type AlertType = (typeof alertEnum)[keyof typeof alertEnum]

const globalAlerts = ref<Alert[]>([])

export const useAlerts = () => {
  const alerts = readonly(globalAlerts)

  const addAlert = (message: string, type: AlertType, options?: AlertOptions) => {
    globalAlerts.value.push(new Alert(message, type, options))
  }

  const deleteAlert = (index: number) => {
    if (index >= 0 && index < globalAlerts.value.length) {
      globalAlerts.value.splice(index, 1)
    }
  }

  const clearAlerts = () => {
    globalAlerts.value = []
  }

  return { alerts, addAlert, deleteAlert, clearAlerts }
}
